import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home'
import Cartographie from '@/components/cartographie/Cartographie'
import Incident from '@/components/incidents/Incident'
import Station from '@/components/stations/Station'
import Parametrage from '@/components/parametrages/Parametrage'
import Inscription from '@/components/authent/Inscription'
import ConfirmationUtil from '@/components/authent/ConfirmationUtil'
import ResetPassword from '@/components/authent/ResetPassword'
import LostPassword from '@/components/authent/LostPassword'
import Cgu from '@/components/pages/Cgu'
import Faq from '@/components/pages/Faq'
import MentionsLegales from '@/components/pages/MentionsLegales'
import storeJs from 'store'


Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/cartographies',
    name: 'Cartographie',
    component: Cartographie,
    props: true,
    beforeEnter : (to, from, next) => {
      if (storeJs.get('prtv:user-id')) {
        next()
      } else {
        next('/')
      }
    }
  }, {
    path: '/incidents',
    name: 'Incident',
    component: Incident,
    beforeEnter : (to, from, next) => {
      if (storeJs.get('prtv:user-id')) {
        next()
      } else {
        next('/')
      }
    }
  }, {
    path: '/stations',
    name: 'Station',
    component: Station,
    beforeEnter : (to, from, next) => {
      if (storeJs.get('prtv:user-id')) {
        next()
      } else {
        next('/')
      }
    }
  }, {
    path: '/parametrages',
    name: 'Parametrage',
    component: Parametrage,
    beforeEnter : (to, from, next) => {
      if (storeJs.get('prtv:user-id')) {
        next()
      } else {
        next('/')
      }
    }
  }, {
    path: '/authent',
    name: 'Inscription',
    component: Inscription
  }, {
    path: '/confirmationUtil',
    name: 'ConfirmationUtil',
    component: ConfirmationUtil
  }, {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword
  },{
    path: '/lostpassword',
    name: 'LostPassword',
    component: LostPassword
  }, {
    path: '/faq',
    name: 'Faq',
    component: Faq
  }, {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: MentionsLegales
  }, {
    path: '/cgu',
    name: 'Cgu',
    component: Cgu
  }, {
    path: '*',
    name: 'Home',
    component: Home
  }]
})

export default router
